const checkIfTypeExistsInName = (arr, name) => {
  const nameLowerCased = name?.toLowerCase();

  const containsWord = (word: string) => {
    return new RegExp(`\\b${word}\\b`).exec(nameLowerCased) != null;
  };

  return arr.some((text) => containsWord(text));
};

export const getFitFeedbackApparelCategoryType = (productType, name) => {
  if (!productType || !name) {
    return;
  }

  const disallowedProductNames = ['boxer', 'boxers', 'panties', 'underwear'];
  if (checkIfTypeExistsInName(disallowedProductNames, name)) {
    return null;
  }

  if (productType === 'bottoms') {
    const shortsArr = ['brief', 'briefs', 'short', 'shorts', 'sweatshort'];
    const dressArr = ['skirt'];
    const pantsArr = [
      'brief',
      'briefs',
      'denim',
      'jean',
      'jeans',
      'jogger',
      'joggers',
      'legging',
      'leggings',
      'pant',
      'pants',
      'sweatpant',
      'sweatpants',
      'tights',
      'trouser',
      'trousers',
    ];

    if (checkIfTypeExistsInName(shortsArr, name)) {
      return 'shorts';
    }

    if (checkIfTypeExistsInName(dressArr, name)) {
      return 'dresses';
    }

    if (checkIfTypeExistsInName(pantsArr, name)) {
      return 'pants';
    }

    return null;
  }

  return productType;
};
